import { SKIP, visit } from 'unist-util-visit';

const TOKEN_REGEX = /\[\[ref:(\d+)\]\]/g;

/**
 * Rehype plugin that turns complete inline `[[ref:n]]` tokens in text nodes into
 * `<citationref data-ref-index="n">n</citationref>` elements, rendered by the
 * markdown `components` map. Only complete tokens match, so a partial `[[ref:`
 * still mid-stream is left untouched as plain text.
 */
export function rehypeCitations() {
  return (tree: unknown): void => {
    visit(tree as never, 'text', (node: any, index: number | undefined, parent: any) => {
      if (index == null || !parent || typeof node.value !== 'string') return;
      // Never rewrite inside code/pre spans.
      if (parent.tagName === 'code' || parent.tagName === 'pre') return;
      const value: string = node.value;
      if (!value.includes('[[ref:')) return;

      TOKEN_REGEX.lastIndex = 0;
      const replacement: any[] = [];
      let lastIndex = 0;
      let match: RegExpExecArray | null;
      let matched = false;

      while ((match = TOKEN_REGEX.exec(value)) !== null) {
        matched = true;
        if (match.index > lastIndex) {
          replacement.push({ type: 'text', value: value.slice(lastIndex, match.index) });
        }
        const n = Number(match[1]);
        replacement.push({
          type: 'element',
          tagName: 'citationref',
          properties: { dataRefIndex: String(n) },
          children: [{ type: 'text', value: String(n) }],
        });
        lastIndex = match.index + match[0].length;
      }

      if (!matched) return;
      if (lastIndex < value.length) {
        replacement.push({ type: 'text', value: value.slice(lastIndex) });
      }

      parent.children.splice(index, 1, ...replacement);
      return [SKIP, index + replacement.length];
    });
  };
}
